import React from 'react';
import styled from 'styled-components';
import {
  brandColours,
  breakpointSizes,
  fluidFontSize,
  fontWeights,
  headingStyles,
  minBreakpointQuery,
} from '../../styles';
import { RichText } from './RichText';

export const StyledHtmlContent = styled.div`
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 12px;
    line-height: 1.3;

    ${minBreakpointQuery.small`
      margin-bottom: 14px;
    `}
  }

  h2 {
    ${headingStyles()};
  }

  h3 {
    ${fluidFontSize(
      '20px',
      '32px',
      breakpointSizes.tiny,
      breakpointSizes.xxxxlarge,
    )};
    font-weight: ${fontWeights.regular};
  }

  h4 {
    font-weight: ${fontWeights.regular};
    ${fluidFontSize(
      '18px',
      '30px',
      breakpointSizes.tiny,
      breakpointSizes.xxxxlarge,
    )};
  }

  h5 {
    font-weight: ${fontWeights.regular};
    ${fluidFontSize(
      '16px',
      '28px',
      breakpointSizes.tiny,
      breakpointSizes.xxxxlarge,
    )};
  }

  h6 {
    font-weight: ${fontWeights.regular};
    ${fluidFontSize(
      '14px',
      '26px',
      breakpointSizes.tiny,
      breakpointSizes.xxxxlarge,
    )};
  }

  p {
    margin-bottom: 20px;
    line-height: 1.3;
    ${fluidFontSize(
      '14px',
      '26px',
      breakpointSizes.tiny,
      breakpointSizes.xxxxlarge,
    )};

    ${minBreakpointQuery.small`
      margin-bottom: 24px;
    `}

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: ${brandColours.secondary};
    text-decoration: underline;
  }

  ul,
  ol {
    margin-bottom: 20px;

    ${minBreakpointQuery.small`
      margin-bottom: 24px;
    `}

    &:last-child {
      margin-bottom: 0;
    }

    li {
      margin-bottom: 10px;
      line-height: 1.3;
      ${fluidFontSize(
        '14px',
        '26px',
        breakpointSizes.tiny,
        breakpointSizes.xxxxlarge,
      )};

      ${minBreakpointQuery.small`
        margin-bottom: 12px;
      `}

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  ul {
    li {
      position: relative;
      padding-left: 20px;

      &:before {
        content: '';
        position: absolute;
        top: 8px;
        left: 0;
        display: inline-block;
        height: 8px;
        width: 8px;
        background-color: ${brandColours.primary};
        border-radius: 50%;
      }
    }
  }

  ol {
    list-style-type: decimal;

    li {
      margin-left: 16px;
    }
  }

  blockquote {
    margin: 20px 0;

    ${minBreakpointQuery.small`
      margin-top: 30px;
      margin-bottom: 30px;
    `}

    ${minBreakpointQuery.large`
      margin-top: 40px;
      margin-bottom: 40px;
    `}

    p {
      color: ${brandColours.secondary};
      font-weight: ${fontWeights.bold};
      line-height: 1.2;

      ${fluidFontSize(
        '32px',
        '50px',
        breakpointSizes.tiny,
        breakpointSizes.xxxxlarge,
      )};
    }
  }

  iframe[src^="https://www.youtube"]
  {
    height: auto;
    width: 100%;
    aspect-ratio: 16 / 9;
  }
`;

export const HtmlContent = ({ content, options, ...props }) => (
  <StyledHtmlContent {...props}>
    {typeof content === 'object' ? (
      <RichText content={content} options={options} />
    ) : (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    )}
  </StyledHtmlContent>
);
